import React from 'react';
import { clsx } from 'clsx';
import { CellComponentProps } from '../types';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

const ASPECT_RATIOS = [
  { value: 2.39, display: '2.39:1 (default)' },
  { value: 1.18, display: '1.18:1' },
  { value: 1.33, display: '1.33:1' },
  { value: 1.66, display: '1.66:1' },
  { value: 1.75, display: '1.75:1' },
  { value: 1.77, display: '1.77:1' },
  { value: 1.78, display: '1.78:1' },
  { value: 1.85, display: '1.85:1' },
  { value: 1.9, display: '1.9:1' },
  { value: 2, display: '2:1' },
  { value: 2.2, display: '2.2:1' },
  { value: 2.35, display: '2.35:1' },
  { value: 2.55, display: '2.55:1' },
  { value: 5, display: '5:1' },
];

interface AspectRatioSelectProps extends CellComponentProps {
  disabled?: boolean;
  invalid?: boolean;
}

const AspectRatioSelect = React.forwardRef<any, AspectRatioSelectProps>(({
  value,
  onChange,
  isExpanded = false,
  disabled = false,
  invalid = false
}, ref) => {
  // Convert backend float value to display format
  const getDisplayValue = (backendValue: string | number | any[]): string => {
    if (!backendValue || Array.isArray(backendValue)) return '';
    
    const numValue = typeof backendValue === 'string' ? parseFloat(backendValue) : backendValue;
    if (isNaN(numValue)) return '';
    
    const aspectRatio = ASPECT_RATIOS.find(ar => ar.value === numValue);
    return aspectRatio ? aspectRatio.value.toString() : numValue.toString();
  };

  // Convert display value back to backend float
  const handleValueChange = (displayValue: string) => {
    const numValue = parseFloat(displayValue);
    if (!isNaN(numValue)) {
      onChange(numValue.toString());
    }
  };

  const currentValue = getDisplayValue(value);

  return (
    <Select value={currentValue} onValueChange={handleValueChange} disabled={disabled}>
      <SelectTrigger className={clsx(
        "tw-w-full tw-h-auto tw-min-h-[2.5rem]",
        invalid && "!tw-border-red-500 focus-visible:!tw-ring-red-500"
      )}>
        <SelectValue placeholder="Select..." />
      </SelectTrigger>
      <SelectContent>
        {ASPECT_RATIOS.map((aspectRatio) => (
          <SelectItem key={aspectRatio.value} value={aspectRatio.value.toString()}>
            {aspectRatio.display}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
});

AspectRatioSelect.displayName = 'AspectRatioSelect';

export default AspectRatioSelect;